
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { User } from "@/models/user";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			addUsersModal: false,
			selectedRows: [] as User[]
		};
	},
	props: {
		value: {
			type: Object as () => Dossier,
			required: true
		},
		company: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		columns():any[] {
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Username",
					property: "username",
					width: "200px"
				},
				{
					name: "Email",
					property: "email",
					width: "200px"
				}
			];
		}
	}
});
